import React, { useContext } from "react";
import { HOME_PAGE } from "../..";
import { NavContext } from "../../context/nav";
import { IHeroComposition } from "../../interfaces/IHero";
import { ImageBox } from "../utils";
import {
  Content,
  Image,
  Name,
  Photo,
  Role,
  Section,
  Welcome,
} from "./styles/Hero";

const Hero: React.FC & IHeroComposition = ({ children, ...restProps }) => {
  const { NavOpen } = useContext(NavContext);
  return (
    <Section navOpen={NavOpen} {...restProps}>
      {children}
    </Section>
  );
};

Hero.Content = function HeroContent({ children, ...restProps }) {
  return <Content {...restProps}>{children}</Content>;
};

Hero.Welcome = function HeroWelcome({ children, ...restProps }) {
  return <Welcome {...restProps}>{children}</Welcome>;
};

Hero.Name = function HeroName({ children, ...restProps }) {
  return <Name {...restProps}>{children}</Name>;
};

Hero.Role = function HeroRole({ children, ...restProps }) {
  return <Role {...restProps}>{children}</Role>;
};

Hero.Image = function HeroImage({ ...restProps }) {
  return (
    <Image {...restProps}>
      <ImageBox>
        <Photo src={`${HOME_PAGE}/img/profile.jpg`} alt='image-profile' />
      </ImageBox>
    </Image>
  );
};

export default Hero;
